import { useEffect } from 'react';

// TODO: Can we hook into react-router navigation easily too?
export default function useUnsavedChangesConfirmation(
  hasChanges: boolean,
  message = 'Do you want to discard these changes?'
) {
  useEffect(() => {
    const handleBeforeUnload = event => confirmBrowserNavigation(event, hasChanges, message);
    window.addEventListener('beforeunload', handleBeforeUnload);

    const handleClick = event => confirmTurboNavigation(event, hasChanges, message);
    document.addEventListener('click', handleClick, { capture: true });

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      document.removeEventListener('click', handleClick, { capture: true });
    };
  }, [hasChanges]);
}

let confirmedTurboNavigation = false;
function confirmTurboNavigation(event: MouseEvent, hasChanges: boolean, message: string) {
  const turboLink = (event.target as Element)?.closest('a[data-turbo="true"]');

  if (turboLink && hasChanges && !confirmedTurboNavigation) {
    event.preventDefault();

    if (confirm(message)) {
      confirmedTurboNavigation = true;
      (turboLink as HTMLElement).click();
      confirmedTurboNavigation = false;
    }
  }
}

function confirmBrowserNavigation(event: BeforeUnloadEvent, hasChanges: boolean, message: string) {
  if (hasChanges) {
    event.preventDefault();
    return event.returnValue = message;
  }
}
